export class LapiError extends Error {
  statusCode: number;

  constructor(statusCode: number, rawResponse: string) {
    super(`${statusCode}: ${rawResponse}`);
    this.name = 'LapiError';
    this.statusCode = statusCode;
  }
}
